import { createContext } from "react";

export const AnalyticContext = createContext();
